import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent.js';

const rawCssPrefix = `
& {
	position: relative;
}
`;

export default InjectedStyledComponent('section', 'app', ['wrapper'], undefined, rawCssPrefix);
